import React from "react";

const circles = [
  { size: 100, top: "12%", left: "8%", color: "#BB0000", delay: "0s", dur: "5s" },
  { size: 60, top: "20%", right: "12%", color: "#A8A9AD", delay: "1.2s", dur: "6s" },
  { size: 40, bottom: "18%", left: "16%", color: "#A8A9AD", delay: "0.6s", dur: "4.5s" },
  { size: 75, bottom: "12%", right: "9%", color: "#BB0000", delay: "1.8s", dur: "5.5s" },
  { size: 25, top: "45%", left: "45%", color: "#BB0000", delay: "0.9s", dur: "4s" },
];

export const FloatingCircles = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
    {circles.map((c, i) => (
      <span
        key={i}
        className="kk-float"
        style={{
          width: c.size,
          height: c.size,
          top: c.top,
          left: c.left,
          right: c.right,
          bottom: c.bottom,
          background: c.color,
          animationDelay: c.delay,
          animationDuration: c.dur,
        }}
      />
    ))}
  </div>
);

export default FloatingCircles;
